

















































































































import { noNotificationView, NotificationSectionViewFactory } from '@/components/molecules/notification-section/model/notification-section-model'
import { log } from '@/log'

import { ApiCoupon } from '@/models/api/coupon'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import DropdownSelect from '@spa/components/atoms/DropdownSelect.vue'
import { InitialLabelItem, SelectItem } from '@spa/components/atoms/model/SelectItem'
import SpaAcordionLike from '@spa/components/atoms/transition/AcordionLike.vue'
import {
  discountPriceView,
  emptyView,
} from '@spa/components/organisms/order/coupon/ApplyCoupon/apply-coupon-result-view'
import { AppliedCouponState, ApplyCouponState, NotApplicableCouponState } from '@spa/components/pages/order/order/apply-coupon/apply-coupon-state'
import { PurchaseEstimate } from '@spa/services/api/purchase'
import { CartItem } from '@spa/store/modules/cart/types'
import _ from 'lodash'
import Vue, { VueConstructor } from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'
import InputCouponCode from './InputCouponCode.vue'
import { useNoCouponOptionValue } from './option-state'

@Component({
  components: {
    InputCouponCode,
    SpaAcordionLike,
    DropdownSelect,
  },
})
/**
 * 責務
 * - ユーザのアクションにより、適用したいクーポンを確定する。
 * - 選択式クーポンについては、その一覧を表示し、ユーザによる選択アクションに供する。
 *
 * クーポンはその入力方式で以下に分類される。
 * - セレクトボックスで選択する選択式クーポン（SelectableCoupon）
 *   => クーポンコード導入以前のクーポンはここに属し、必ずしも"selectable"の接頭辞なく無印でCouponと呼ばれているのが現状である。
 * - ユーザがコードを入力するクーポンコード（CouponCode）
 */
export default class ApplyCoupon extends Vue {
  @Prop({ required: true })
  readonly applyCouponState: ApplyCouponState

  @Prop({ required: true })
  readonly behavior: BehaviorConfig

  @Prop({ required: true })
  coupons: ApiCoupon[]

  @Prop({ required: true })
  couponCode: string

  @Prop({ required: true })
  itemsInCart: CartItem[]

  @Prop({ required: true })
  purchaseEstimates: PurchaseEstimate[]

  @Prop({ default: false })
  readonly loading: boolean

  isAccordionOpen = false

  get appliedCoupon(): ApiCoupon | null {
    return this.applyCouponState.coupon.toNullable()
  }
  get appliedCouponId(): string | null {
    return this.appliedCoupon ? this.appliedCoupon.id : null
  }

  get couponApplyResultView(): VueConstructor {
    if (this.applyCouponState instanceof NotApplicableCouponState) {
      return emptyView('some-errors')
    }

    if (this.applyCouponState instanceof AppliedCouponState) {
      return discountPriceView(this.applyCouponState.discount)
    }

    return emptyView('coupon-not-applying')
  }

  get isCouponCodeApplied(): boolean {
    return this.applyCouponState.coupon.fold(false, c => c.hasCouponCode)
  }

  /** 選択式クーポン */
  get appliedSelectableCoupon(): ApiCoupon | null {
    return this.coupons.find(c => c.id === this.appliedCouponId) || null
  }

  get everyItemsArePreSale(): boolean {
    return this.itemsInCart.every(i => i.isPreSales)
  }

  get containPreSaleItem(): boolean {
    return this.itemsInCart.some(i => i.isPreSales)
  }

  get containItemIneligibleForCoupon(): boolean {
    return this.itemsInCart.some(i => i.ineligibleForCoupon)
  }

  get initialLabelItem(): InitialLabelItem {
    return {
      text: '選択してください',
      value: useNoCouponOptionValue,
    }
  }

  get selectItemList(): SelectItem[] {
    return this.makeInitialList(this.coupons)
  }

  // アコーディオンの開閉切り替え.
  onToggleAccordion() {
    log.debug('onToggleAccordion')
    this.isAccordionOpen = !this.isAccordionOpen
  }

  // ドロップダウンからクーポンが選択された時.
  onSelectableCouponApply(couponId: string): void {
    const selected = this.coupons.find(c => c.id === couponId)

    selected ? this.apply(selected) : this.unapply()
  }

  @Emit()
  apply(coupon: ApiCoupon) {
    return coupon
  }

  @Emit()
  unapply() {
    return null
  }

  @Emit('input-coupon-code')
  onInputCouponCode(couponCode: string) {
    return couponCode
  }

  get errorSection(): VueConstructor {
    if (this.errorMessages.length === 0) {
      return noNotificationView
    }

    return NotificationSectionViewFactory.create('alert', {
      type: 'with-icon',
      body: this.errorMessages.join('<br>'),
    })
  }

  get errorMessages(): string[] {
    return this.applyCouponState instanceof NotApplicableCouponState ?
      this.applyCouponState.errors.map(e => e.label) : []
  }

  get warningMessages(): string[] {
    return [
      ...this.coupons.length > 0 ? ['クーポンとクーポンコードは併用できません。'] : [],
      ...this.containPreSaleItem ? ['クーポンは予約商品には適用されません。'] : [],
      ...this.containItemIneligibleForCoupon ? ['クーポン対象外の商品が含まれています。'] : [],
    ]
  }

  private makeInitialList(coupons: ApiCoupon[]): SelectItem[] {
    const noCoupon: SelectItem = {
      text: 'クーポンを使用しない',
      value: useNoCouponOptionValue,
      selected: this.appliedCouponId === useNoCouponOptionValue,
      disabled: false,
    }

    return [
      noCoupon,
      ..._.map(coupons, (coupon: ApiCoupon) => ({
        text: this.makeTitle(coupon),
        value: coupon.id,
        selected: this.appliedCouponId === coupon.id,
      })),
    ]
  }

  private makeTitle(coupon: ApiCoupon): string {
    return `${coupon.title} ${coupon.labelMaker.makeDiscountContentLabel()}`
  }
}
